import { designToken, quickProperty } from '../component-tokens';
export const thumbnailData = {
    name: 'thumbnail',
    tag: 'chameleon-thumbnail',
    reactImports: 'Thumbnail',
    attributes: {
        display: quickProperty('inline-flex'),
        'align-items': quickProperty('center'),
    },
    sizes: [
        {
            name: 'small',
            children: [
                {
                    name: 'icon',
                    attributes: {
                        '--goto-icon-size': quickProperty('1.875rem'),
                    },
                },
            ],
        },
        {
            name: 'large',
            attributes: {
                'flex-direction': quickProperty('column'),
                'text-align': quickProperty('center'),
            },
            children: [
                {
                    name: 'icon',
                    attributes: {
                        '--goto-icon-size': quickProperty('6.25rem'),
                    },
                },
            ],
        },
    ],
    children: [
        {
            name: 'icon',
            attributes: {
                '--goto-icon-size': quickProperty('2.75rem'),
                position: quickProperty('relative'),
            },
            children: [
                {
                    name: 'badge',
                    attributes: {
                        display: quickProperty('grid'),
                        'place-items': quickProperty('center'),
                        position: quickProperty('absolute'),
                        left: quickProperty('50%'),
                        top: quickProperty('50%'),
                        transform: quickProperty('translate(-50%, -50%)'),
                    },
                },
            ],
        },
        {
            name: 'metadata',
            attributes: {
                'flex-direction': quickProperty('column'),
            },
        },
    ],
    variants: [
        {
            name: 'pdf',
            attributes: {
                '--goto-icon-color': designToken('badge-color-customer'),
                'background-color': designToken('surface-color-danger-secondary'),
            },
        },
        {
            name: 'document',
            attributes: {
                '--goto-icon-color': designToken('badge-color-message'),
                'background-color': designToken('surface-color-brand-secondary'),
            },
        },
        {
            name: 'spreadsheet',
            attributes: {
                '--goto-icon-color': designToken('badge-color-voice'),
                'background-color': designToken('surface-color-success-secondary'),
            },
        },
        {
            name: 'audio',
            attributes: {
                '--goto-icon-color': designToken('badge-color-audio'),
                'background-color': designToken('surface-color-warning-secondary'),
            },
        },
        {
            name: 'video',
            attributes: {
                '--goto-icon-color': designToken('badge-color-gotoresolve'),
                'background-color': designToken('surface-color-utility-purple'),
            },
        },
        {
            name: 'sketch',
            attributes: {
                '--goto-icon-color': designToken('badge-color-meeting'),
                'background-color': designToken('surface-color-utility-orange'),
            },
        },
    ],
};
